import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/styles';
import { Select, MenuItem } from '@material-ui/core';
import { PERIOD_OPTIONS, PERIOD_OPTIONS_DEFERRED, PERIOD_OPTIONS_MONTHLY } from '../views/DashboardDefault/helpers';
import { useSelector } from 'react-redux';
import { selectCompany } from 'src/actions/company/companySelectors';

const useStyles = makeStyles((theme) => ({
  root: {
    borderRadius: 2,
    width: 155,
    background: theme.palette.common.white,
    fontSize: '14px',
    boxShadow: '0 1px 3px 0 rgba(70, 79, 86, 0.05)'
  }
}));

const TimeframeDropdown = ({
  onChange,
  period,
  className
}) => {
  const classes = useStyles();
  const currentCompany = useSelector(selectCompany);
  const displayedPeriods = (currentCompany?.settings?.paymentFrequency === 'monthly (deferred)') ?PERIOD_OPTIONS_DEFERRED :PERIOD_OPTIONS_MONTHLY

  return (
    <Select
      className={clsx(classes.root, className)}
      fullWidth
      name="option"
      onChange={onChange}
      variant="outlined"
      value={PERIOD_OPTIONS.find(({ value }) => value === period).value} // should be PERIOD as state
    >
      {displayedPeriods.map(({ value, label }) => (
        <MenuItem
          key={value}
          value={value}
        >
          {label}
        </MenuItem>
      ))}
    </Select>
  );
}

TimeframeDropdown.propTypes = {
  className: PropTypes.string,
  onChange: PropTypes.func,
  period: PropTypes.string
};

export default TimeframeDropdown;
